/**
 * Cart upgrade — per-line subscription upgrade
 *
 * Listens at document level for clicks on any [data-cart-upgrade] button.
 * On click: POST /cart/change.js with the line key + selling_plan,
 * then dispatch cart:refresh so the drawer re-renders. The new HTML
 * will no longer contain an upgrade row for that line, so the button
 * naturally disappears.
 */

(function () {
  if (window.__cartUpgradeInit) return;
  window.__cartUpgradeInit = true;

  document.addEventListener('click', async function (event) {
    const btn = event.target.closest('[data-cart-upgrade]');
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled) return;

    const lineKey = btn.dataset.lineKey;
    const planId = btn.dataset.planId;
    const quantity = Number(btn.dataset.quantity);
    if (!lineKey || !planId || !quantity) return;

    btn.disabled = true;
    btn.dataset.loading = 'true';

    let updatedCart = null;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity, selling_plan: planId }),
      });
      if (res.ok) updatedCart = await res.json();
    } catch (e) {
      /* network error — let cart:refresh re-sync */
    }

    if (updatedCart) {
      document.dispatchEvent(new CustomEvent('CartUpdated', { detail: updatedCart }));
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
  });
})();
